import { Trans } from '@lingui/react/macro';
import React from 'react';
import { ChangeRequest, SellerChangeRequestStatus, TranslatableText } from '@/types';
import theme from './ResidentialUnitDashboard.module.scss';
import { SimpleBarChart } from '@ygtechnologies/bygr-frontend-component-library';
import { useLingui } from '@lingui/react';

interface ChangeRequestRow {
    label: TranslatableText;
    value: number;
}
interface ResidentialUnitDashboardChangeRequestsProps {
    changeRequests: ChangeRequest[];
}

const ResidentialUnitDashboardChangeRequests: React.FC<ResidentialUnitDashboardChangeRequestsProps> = ({
    changeRequests,
}) => {
    const { _ } = useLingui();

    const crData: number[] = [];

    if (changeRequests.length === 0) {
        return (
            <span className={theme.noDataMessage}>
                <Trans>No change requests</Trans>
            </span>
        );
    }

    changeRequests.forEach((x) => (crData[x.status] = !isNaN(crData[x.status]) ? crData[x.status] + 1 : 1));

    const chartData: ChangeRequestRow[] = Object.keys(SellerChangeRequestStatus)
        // Doing it this way to make it sort by the way the enum is,
        // Filtering out where there is no data.
        .filter((key) => crData[key])
        .map((key) => ({ label: _({ id: `ChangeRequestStatus.${key}` }), value: crData[key] }));

    return <SimpleBarChart<ChangeRequestRow> data={chartData} nameKey={'label'} valueKey={'value'} />;

    // return (
    //     <div className={theme.infoGrid}>
    //         {Object.keys(SellerChangeRequestStatus)
    //             // Doing it this way to make it sort by the way the enum is,
    //             // Filtering out where there is no data.
    //             .filter((key) => crData[key])
    //             .map((key) => (
    //                 <Fragment key={key}>
    //                     <span className={theme.label}>
    //                         <Trans id={`ChangeRequestStatus.${key}`} />:
    //                     </span>
    //                     <span>{crData[key]}</span>
    //                 </Fragment>
    //             ))}
    //         <div className={theme.line} />
    //         <span className={theme.label}>
    //             <Trans>Total:</Trans>
    //         </span>
    //         <span>{changeRequests.length}</span>
    //     </div>
    // );
};

export default ResidentialUnitDashboardChangeRequests;
